import { namespace } from 'vuex-class'
import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { RawLocation } from 'vue-router'
// import { VuetifyBreakpoint } from 'vuetify/types/services/breakpoint'

const _namespace = 'navigation'
export const StateNavigation = namespace(_namespace).State
export const GetterNavigation = namespace(_namespace).Getter
export const MutationNavigation = namespace(_namespace).Mutation
export const ActionNavigation = namespace(_namespace).Action

export interface NavigationItem {
  title: string
  titleShort?: string
  icon?: string
  iconColor?: string
  to: RawLocation
  roles: string[]
  exact?: boolean
  mobile?: boolean
}

export interface NavigationState {
  // breakpoint: VuetifyBreakpoint | null,
  mainMenuDefinition: NavigationItem[],
  userMenuDefinition: NavigationItem[]
}

@Module({ namespaced: true, name: _namespace })
export default class NavigationModule extends VuexModule implements NavigationState {
  // breakpoint: VuetifyBreakpoint | null = null

  mainMenuDefinition: NavigationItem[] = [
    {
      title: 'Le Club',
      titleShort: 'Club',
      icon: 'mdi-pencil',
      to: { name: 'LeClub' },
      roles: ['ROLE_USER']
    }
  ]
  userMenuDefinition: NavigationItem[] = [
    {
      title: 'Mon profil',
      icon: 'mdi-account-card-details',
      iconColor: 'primary',
      roles: ['ROLE_USER', 'ROLE_ADMIN'],
      to: { name: 'monProfil' }
    },
    {
      title: 'Se déconnecter',
      icon: 'mdi-logout',
      iconColor: 'secondary',
      roles: ['ROLE_USER', 'ROLE_ADMIN'],
      to: { name: 'logout' }
    }
  ]

  // @Mutation
  // setBreakpoint (breakpoint: VuetifyBreakpoint) {
  //   this.breakpoint = breakpoint
  // }

  // get mobile (): boolean {
  //   return this.breakpoint ? this.breakpoint.xsOnly : false
  // }

  get mainMenu () {
    return this.mainMenuDefinition
    // return this.mainMenuDefinition.filter((item) => item.mobile === undefined || (this.mobile ? item.mobile : !item.mobile))
  }

  get userMenu () {
    return this.userMenuDefinition
    // return this.userMenuDefinition.filter((item) => item.mobile === undefined || (this.mobile ? item.mobile : !item.mobile))
  }
}
